var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJudo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 68.1,
    cy: 34.7,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.3,
    cy: 83.6,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1,62.1L52.2,38.2c-4.5-4.5-11.9-4.5-16.4,0L14.7,59.3l16.4,16.4l21.9-22L79.4,80c2.3,2.3,5.2,3.4,8.2,3.4h41.7 l-21.3-21.3H76.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,19.7l-16.5,16.5c-1,1-1.5,2.3-1.5,3.6v18.4l-19.3-19.3V10.3c0-2.8-2.3-5.1-5.1-5.1c-2.8,0-5.1,2.3-5.1,5.1v30.9 c0,1.4,0.6,2.7,1.5,3.6l35,35c2.3-2.3,3.4-5.2,3.4-8.2V42l7.7-7.7L144,19.7L144,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3,99.2L11.1,63c-2.3,2.3-3.4,5.2-3.4,8.2v29.4l0.1,0L0,108.4V123l16.5-16.5c1-1,1.5-2.3,1.5-3.6V84.4L38.6,105v28.7 c0,2.8,2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1v-30.9C48.8,101.4,48.3,100.2,47.3,99.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJudo);
export default __webpack_public_path__ + "static/media/judo.d146185a20e7b4ed7497f935b80bb02e.svg";
export { ForwardRef as ReactComponent };